import _ from 'lodash';

import BadgeService from 'scripts/services/badge-service';
import PlayerService from 'scripts/services/player-service';
import dtm from 'scripts/services/dtm';

function isTagContainsFavorite(tagKey) {
    const playerId = tagKey.substring(tagKey.lastIndexOf('_') + 1);
    return PlayerService.isInFavorites(playerId);
}

function getBadgeType(tagKey) {
    switch (true) {
        case _.includes(tagKey, '_players_') && isTagContainsFavorite(tagKey):
            return 'Favorite Player';
        case _.includes(tagKey, '_badges_live'):
            return 'Live';
        case _.includes(tagKey, '_badges_trending'):
            return 'Trending';
        case _.includes(tagKey, '_history'):
            return 'Historical';
        default:
            return '';
    }
}

function sendBadgingServiceCardClick(cardId) {
    if (!cardId) {
        return;
    }

    BadgeService.trackCardClick(cardId);
}

function sendAnalyticsCardClick(tags, url, title) {
    if (!tags || !url || !title) {
        return;
    }

    const badges = tags.reduce((memo, tag) => {
        const tagType = getBadgeType(tag.key);

        if (!tagType) {
            return memo;
        }

        return [...memo, tagType];
    }, []);

    badges.forEach((badge) => {
        dtm.trackLatestBadgedCardClick(badge, url, title);
    });
}

function sendLatestTimelinePinnedContentAnalytics(card) {
    const cardTitle = _.get(card, 'title');
    const isPinned = _.get(card, 'isPinned');
    if (isPinned) {
        dtm.trackLatestPinnedCardClick(cardTitle);
    }
}

function sendLatestCardNumberInteractions(cardIndex) {
    if (cardIndex > 0) {
        dtm.trackLatestCardNumberClick(cardIndex);
    }
}

export const clickHandler = _.memoize(
    (card) => {
        sendBadgingServiceCardClick(_.get(card, 'identifier'));
        sendAnalyticsCardClick(
            _.get(card, 'tags'),
            _.get(card, 'shareUrl'),
            _.get(card, 'title'),
        );
    },
    (card) => _.get(card, 'identifier'),
);

export const vcAnalyticsHandler = _.memoize(
    (card, cardIndex) => {
        sendLatestTimelinePinnedContentAnalytics(card);
        sendLatestCardNumberInteractions(cardIndex);
    },
    (card) => _.get(card, 'identifier'),
);
